import Vue from "vue";
import axios from "axios";
import router from "@/router/router";
import store from './../store/index'
import { Ddebounce, generateString } from "@/utils/tools.js";
import utils from './../utils/utils';
import VConsole from 'vconsole';

const currentENV = process.env.NODE_ENV
const HOST = currentENV === 'production' ? location.origin + '/' : ''
if (location.origin=="http://wx-dev.youxiangzb.com"||location.origin=="http://wx-test.youxiangzb.com") {
  new VConsole();
}
let baseHeader = {}
let WXTOKEN = ''
// 当前正在请求的数量
let needLoadingRequestCount = 0;
// 显示loading
function showLoading() {
  // needLoadingRequestCount++;
  // if (needLoadingRequestCount > 0) {
  //   store.commit('setLoading', true)
  // }
}

// 隐藏loading
function hideLoading() {
  // needLoadingRequestCount--;
  // if (needLoadingRequestCount <= 0) {
  //   toHideLoading();
  // }
}

let toHideLoading = Ddebounce(() => {
  store.commit('setLoading', false)
}, 500, false);

let testHEAD = '';

function setbaseHeader() {
  WXTOKEN = localStorage.getItem('token');
  const user_id = localStorage.getItem('user_id')
  const addrObj = JSON.parse(localStorage.getItem('location'))
  const addr = encodeURIComponent(addrObj?.data?.province + '-' + addrObj?.data?.city + '-' + addrObj?.data?.district)
  const adcode = addrObj?.data?.adcode
  let session_id = localStorage.getItem('session_id')
  if (!session_id) {
    let time = new Date().getTime()
    let tmp = generateString('xxxx')
    session_id = String(time) + (user_id ? String(user_id) : String(1)) + String(tmp)
    localStorage.setItem('session_id', session_id)

  }
  //TODO 上线前去掉
  testHEAD = JSON.stringify({
    vid: localStorage.getItem('openid') || '',
    sid: session_id,
    ua: navigator.userAgent,
    addr,
    adcode,
    act_id: localStorage.getItem('act_id') || 0,
    brand_id: localStorage.getItem('brand_id') || 0,
    shop_id: localStorage.getItem('shop_id') || 0,
    userType: localStorage.getItem('userType') || '',
    kpi_user_id: localStorage.getItem('kpi_user_id') || 0,
    share_user_id: localStorage.getItem('share_user_id') || 0,
    user_id,
  });

  baseHeader = window.btoa(JSON.stringify({
    vid: localStorage.getItem('openid') || '',
    sid: session_id,
    ua: navigator.userAgent,
    addr,
    adcode,
    act_id: localStorage.getItem('act_id') || 0,
    brand_id: localStorage.getItem('brand_id') || 0,
    shop_id: localStorage.getItem('shop_id') || 0,
    userType: localStorage.getItem('userType') || '',
    kpi_user_id: localStorage.getItem('kpi_user_id') || 0,
    share_user_id: localStorage.getItem('share_user_id') || 0,
    user_id,
  }))
}

const service = axios.create({
  baseURL: HOST,
  timeout: 30000, // 请求超时时间
  headers: {},
});



// 请求拦截器

service.interceptors.request.use(config => {
  setbaseHeader()
  config.headers['WX-TOKEN'] = WXTOKEN;
  config.headers['ACTIVITY-BASE'] = baseHeader;
  // config.headers['ACTIVITY-TEST'] = testHEAD;
  console.log('currentENV:', currentENV)
  if (!WXTOKEN && currentENV === 'production') {
    // router.replace('/login')
    console.log('未登录')

  } else if (WXTOKEN && !store.state.hadRefreshLogin) {
    utils.updateUserInfo()
    store.commit('setHadRefreshLogin', true)
  }
  config.cancelToken = new axios.CancelToken(cancel => {
    store.commit('PUSH_CANCEL', {
      cancelToken: cancel
    })
  })
  return config;
}, (error) => {
  return error;
});


// 返回拦截器

service.interceptors.response.use(response => {
  console.log('currentENV:', currentENV)
  if (!response) {
    return Vue.prototype.$toast('数据请求失败');
  }
  if (response.data.code === 20404 || response.data.code === 10102) {
    return catchResponseError(response);
  }
  return response;
});
function catchResponseError(res) {
  console.log('catch response,', res, currentENV)
  if (res?.data?.code === 20404) {
    Vue.prototype.$toast('请先登录');
    localStorage.removeItem('token');
    localStorage.removeItem('user_id');
    currentENV === 'production' && router.push('/login');
  } else if (res?.data?.code === 10102) {
    console.log('token过期，10102')
    localStorage.removeItem('token');
    localStorage.removeItem('user_id');
    currentENV === 'production' && router.push('/login');
  }

}

// 挂载请求
Vue.prototype.$axios = service;

// 请求统一处理
function requst(options) {
  return new Promise((resolve, reject) => {
    options
      .then(res => {
        // 返回图片流方式处理
        if (res?.config?.url.includes("/login/captcha")) {
          resolve('data:image/png;base64,' + btoa(new Uint8Array(res?.data).reduce((data, byte) => data + String.fromCharCode(byte), '')))
        } else {
          // 10102=>token过期   20404=>token和act不一致   
          if (res?.data?.code !== 10102 && res?.data?.code !== 20404) {
            // 10200=>无数据   20302=>获取用户access_token异常
            if (res?.data?.code !== 0 && res?.data?.code !== 10200 && res?.data?.code !== 20302 && res?.data?.code !== 20706) {
              if (res?.data.msg || res?.data.Msg) {
                Vue.prototype.$toast(res?.data.msg || res?.data.Msg)
              }
            }
            resolve(res?.data);
          }
        }
      })
      .catch(error => {
        reject(error);
      });
  });
}

// get.post.put.del.patch请求方法提取
const get = (url, params, headerConfig = {}) => {
  return requst(service.get('/wx' + url, { params }, { headers: headerConfig }));
};
const post = (url, params, headerConfig = {}) => {
  return requst(service.post('/wx' + url, params, { headers: headerConfig }));
};
const put = (url, params, headerConfig = {}) => {
  return requst(service.put('/wx' + url, params, { headers: headerConfig }));
};
const del = (url, params, headerConfig = {}) => {
  return requst(
    service.delete('/wx' + url, { params }, { headers: headerConfig })
  );
};
const patch = (url, params, headerConfig = {}) => {
  return requst(service.patch('/wx' + url, { data: params }, { headers: headerConfig }));
};

export default { get, post, put, del, patch };
